import { useQuery } from "@tanstack/react-query";
import { MaterialService } from "./_request";

/**
 * Machine state
 * @param params
 * @returns
 */

export const useQueryMachineMaterialStateSelect = (
  params?: any,
  uriValue = true
) => {
  return useQuery({
    queryKey: ["getMachineMaterialState"],
    queryFn: async () =>
      await MaterialService.getMaterialsStateForSelect(params),
    select(data) {
      if (Array.isArray(data?.data?.member)) {
        return data?.data?.member?.map((item: any) => ({
          ...item,
          label: item?.name,
          value: uriValue ? item?.["@id"] : item?.id,
        }));
      } else {
        return [];
      }
    },
  });
};

/**
 * Machine Energy
 * @param params
 * @returns
 */

export const useQueryMachineMaterialEnergySelect = (
  params?: any,
  uriValue = true
) => {
  return useQuery({
    queryKey: ["getMachineMaterialEnergy"],
    queryFn: async () =>
      await MaterialService.getMaterialsEnergyForSelect(params),
    select(data) {
      if (Array.isArray(data?.data?.member)) {
        return data?.data?.member?.map((item: any) => ({
          ...item,
          label: item?.name,
          value: uriValue ? item?.["@id"] : item?.id,
        }));
      } else {
        return [];
      }
    },
  });
};

/**
 * Machine Energy
 * @param params
 * @returns
 */

export const useQueryMachineMaterialFromSelect = (
  params?: any,
  uriValue = true
) => {
  return useQuery({
    queryKey: ["getMachineMaterialFrom"],
    queryFn: async () =>
      await MaterialService.getMaterialsFromForSelect(params),
    select(data) {
      if (Array.isArray(data?.data?.member)) {
        return data?.data?.member?.map((item: any) => ({
          ...item,
          key: item?.id,
          label: item?.name,
          value: uriValue ? item?.["@id"] : item?.id,
        }));
      } else {
        return [];
      }
    },
  });
};

/**
 * Machine Energy
 * @param params
 * @returns
 */

export const useQueryMachineMaterialTypeSelect = (
  params?: any,
  uriValue = true
) => {
  return useQuery({
    queryKey: ["getMachineMaterialType"],
    queryFn: async () =>
      await MaterialService.getMaterialsTypeForSelect(params),
    select(data) {
      if (Array.isArray(data?.data?.member)) {
        return data?.data?.member?.map((item: any) => ({
          ...item,
          key: item?.id,
          label: item?.name,
          value: uriValue ? item?.["@id"] : item?.id,
        }));
      } else {
        return [];
      }
    },
  });
};

/**
 * Crane TYpe
 * @param params
 * @returns
 */

export const useQueryCraneMaterialTypeSelect = (
  params?: any,
  uriValue = true
) => {
  return useQuery({
    queryKey: ["getCraneMaterialType"],
    queryFn: async () =>
      await MaterialService.getCraneMaterialsTypeForSelect(params),
    select(data) {
      if (Array.isArray(data?.data?.member)) {
        return data?.data?.member?.map((item: any) => ({
          ...item,
          label: item?.name,
          value: uriValue ? item?.["@id"] : item?.id,
        }));
      } else {
        return [];
      }
    },
  });
};

/**
 * Lifting TYpe
 * @param params
 * @returns
 */

export const useQueryLiftingMaterialTypeSelect = (
  params?: any,
  uriValue = true
) => {
  return useQuery({
    queryKey: ["getLiftingMaterialType"],
    queryFn: async () =>
      await MaterialService.getLiftingMaterialsTypeForSelect(params),
    select(data) {
      if (Array.isArray(data?.data?.member)) {
        return data?.data?.member?.map((item: any) => ({
          ...item,
          label: item?.name,
          value: uriValue ? item?.["@id"] : item?.id,
        }));
      } else {
        return [];
      }
    },
  });
};

/***
 * Machine Select
 *
 */
export const useQueryMachineForSelect = (params?: any, uriValue = true) => {
  return useQuery({
    queryKey: ["getMachineForSelect"],
    queryFn: async () => await MaterialService.getAllMachineForSelect(params),
    select(data) {
      if (Array.isArray(data?.data?.member)) {
        return data?.data?.member?.map((item: any) => ({
          ...item,
          label: item?.name ?? item?.reference,
          value: uriValue ? item?.["@id"] : item?.id,
        }));
      } else {
        return [];
      }
    },
  });
};
/**End Machine select */

/***
 * Grue Select
 *
 */

export const useQueryGrueForSelect = (params?: any, uriValue = true) => {
  return useQuery({
    queryKey: ["getGrueForSelect"],
    queryFn: async () => await MaterialService.getAllGrueForSelect(params),
    select(data) {
      if (Array.isArray(data?.data?.member)) {
        return data?.data?.member?.map((item: any) => ({
          ...item,
          label: item?.name ?? item?.reference,
          value: uriValue ? item?.["@id"] : item?.id,
        }));
      } else {
        return [];
      }
    },
  });
};
/**End Grue select */

/***
 * Listing Select
 *
 */
export const useQueryLiftingForSelect = (params?: any, uriValue = true) => {
  return useQuery({
    queryKey: ["getLiftingForSelect"],
    queryFn: async () => await MaterialService.getAllLevageForSelect(params),
    select(data) {
      if (Array.isArray(data?.data?.member)) {
        return data?.data?.member?.map((item: any) => ({
          ...item,
          label: item?.name ?? item?.reference,
          value: uriValue ? item?.["@id"] : item?.id,
        }));
      } else {
        return [];
      }
    },
  });
};
/**End Lifting select */

/**
 * TUGBOAT select
 *
 * */
export const useQueryTruckForSelect = (params?: any, uriValue = true) => {
  return useQuery({
    queryKey: ["getTruckForSelect"],
    queryFn: async () => await MaterialService.getTugboatForSelect(params),
    select(data) {
      if (Array.isArray(data?.data?.member)) {
        return data?.data?.member?.map((item: any) => ({
          ...item,
          label: item?.name ?? item?.reference,
          value: uriValue ? item?.["@id"] : item?.id,
        }));
      } else {
        return [];
      }
    },
  });
};

/**End TUGBOAT select */

/**
 * CHALAND select
 *
 * */

export const useQueryChalandForSelect = (params?: any, uriValue = true) => {
  return useQuery({
    queryKey: ["getChalandForSelect"],
    queryFn: async () => await MaterialService.getChalandForSelect(params),
    select(data) {
      if (Array.isArray(data?.data?.member)) {
        return data?.data?.member?.map((item: any) => ({
          ...item,
          label: item?.name ?? item?.reference,
          value: uriValue ? item?.["@id"] : item?.id,
        }));
      } else {
        return [];
      }
    },
  });
};

/**End CHALAND select */
